import { __assign, __rest } from "tslib";
import React from 'react';
import clsx from 'clsx';
import { getBaseProps } from '../../base-component';
import InternalBox from '../../../box/internal';
import ChartSeriesMarker from '../chart-series-marker';
import styles from './styles.css.js';
var ChartSeriesDetails = function (_a) {
    var details = _a.details, restProps = __rest(_a, ["details"]);
    var baseProps = getBaseProps(restProps);
    var className = clsx(baseProps.className, styles.root);
    return (React.createElement("div", __assign({}, baseProps, { className: className }),
        React.createElement("ul", { className: styles.list }, details.map(function (_a, i) {
            var key = _a.key, value = _a.value, markerType = _a.markerType, color = _a.color;
            return (React.createElement("li", { key: i },
                React.createElement(InternalBox, { margin: { right: 'xxl' }, color: "text-label", className: styles.key },
                    markerType && color && React.createElement(ChartSeriesMarker, { type: markerType, color: color }),
                    key),
                React.createElement(InternalBox, { textAlign: "right" }, value)));
        }))));
};
export default ChartSeriesDetails;
//# sourceMappingURL=index.js.map